
<template>
    <div class="page-container md-layout-row" v-if="settmenu.length">
      <md-app>
        <md-app-drawer md-permanent="full">
          <md-toolbar class="md-transparent toolbar-setting" style="color: #797979;" md-elevation="0">
            SETTINGS
          </md-toolbar>
          <md-list style="background-color: #fff;">
            <md-list-item v-for="item in settmenu" :key="item.id" :to="item.link">
              <i class="md-icon">{{item.icon}}</i>
              <span class="md-list-item-text">{{item.label}}</span>
            </md-list-item>
          </md-list>
        </md-app-drawer>
        <md-app-content class="content-myacc">
            <div class="viewport-myacc">
                <md-toolbar style="background-color: #fff;" :md-elevation="0">
                <span class="md-title-myacc">My Account</span>
                </md-toolbar>
                <center>
                <div class="img-height-top">
                    <br>
                    <my-upload field="img"
                        @crop-success="cropSuccess"
                        @crop-upload-success="cropUploadSuccess"
                        @crop-upload-fail="cropUploadFail"
                        v-model="show"
                        langType='en'
                        :width="100"
                        :height="100"
                        url=""
                        :params="params"
                        :headers="headers"
                        img-format="png">
                    </my-upload>
                    <img class="img-circle" :src="imgDataUrl"><br>
                    <md-button  @click="toggleShow" title="Upload image"><md-icon>camera_alt</md-icon></md-button>
                </div>
                </center>
                <md-list style="background-color: #fff;">
                    <md-list-item  class="item-list-myacc">
                        <md-field>
                        <label>Username</label>
                        <md-input ></md-input>
                        </md-field>
                    </md-list-item>
                    <md-list-item  class="item-list-myacc">
                        <md-field>
                        <label>Old password</label>
                        <md-input type="password"></md-input>
                        </md-field>
                    </md-list-item>
                    <md-list-item  class="item-list-myacc">
                        <md-field>
                        <label>New password</label>
                        <md-input type="password"></md-input>
                        </md-field>
                    </md-list-item>
                    <md-list-item  class="item-list-myacc">
                        <md-field>
                        <label>Confirm password</label>
                        <md-input type="password"></md-input>
                        </md-field>
                    </md-list-item>
                    <md-list-item  class="item-list-myacc-button"></md-list-item>
                    <md-list-item  class="item-list-myacc-button">
                        <md-button class="md-raised md-primary" style="width: 380px;">save changes</md-button>
                    </md-list-item>
                    <md-list-item  class="item-list-myacc-button"></md-list-item>
                </md-list>
            </div>
        </md-app-content>
      </md-app>
    </div>
</template>
<script>
import myUpload from 'vue-image-crop-upload';
export default {
    name: 'setting-myaccount',
    computed: {
      settmenu (){
        return this.$store.getters['menu/settmenu']
      },
    },
    data: () => ({
			show: false,
			params: {
				token: '123456798',
				name: 'avatar'
			},
			headers: {
				smail: '*_~'
			},
			imgDataUrl: 'https://s3-ap-southeast-1.amazonaws.com/static.getconnectedapp.com/upload_connected/user_profile/defaultuserimg_sq.png' // the datebase64 url of created image
		}),
		components: {
			'my-upload': myUpload
		},
		methods: {
			toggleShow() {
				this.show = !this.show;
			},
            /**
			 * crop success
			 *
			 * [param] imgDataUrl
			 * [param] field
			 */
			cropSuccess(imgDataUrl){
				console.log('-------- crop success --------');
				this.imgDataUrl = imgDataUrl;
			},
			/**
			 * upload success
			 *
			 * [param] jsonData  server api return data, already json encode
			 * [param] field
			 */
			cropUploadSuccess(jsonData, field){
				console.log('-------- upload success --------');
				console.log(jsonData);
				console.log('field: ' + field);
			},
			/**
			 * upload fail
			 *
			 * [param] status    server api return error status, like 500
			 * [param] field
			 */
			cropUploadFail(status, field){
				console.log('-------- upload fail --------');
				console.log(status);
				console.log('field: ' + field);
			}
		}
};
</script>